import { SuccessModal } from '@phx-husky/common-components';
import { useTranslations } from '@phx-husky/use-translations';

export const DeleteAccountSuccessModal = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  const { translate } = useTranslations();

  return (
    <SuccessModal
      isShowing={visible}
      title={translate('securityDeleteSuccessModalTitle')}
      body={translate('securityDeleteSuccessModalMessage')}
      closeButtonLabel={translate('securityDeleteSuccessModalButton')}
      onClose={onClose}
    />
  );
};
